import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-stickynav',
  templateUrl: './stickynav.component.html',
  styleUrls: ['./stickynav.component.css']
})
export class StickynavComponent implements OnInit {

  constructor() { }

  ngOnInit() {

    //Menu toggle-button

$(document).ready(function(){
  $(".menu-icon").on("click", function(){
    $("nav ul").toggleClass("showing");
  });
});

//scrolling effect

$(window).on("scroll", function(){
  if($(window).scrollTop()){
    $('nav').addClass('black');
  }
  else{
    $('nav').removeClass('black');
  }
})
  }

}



// WEBPACK FOOTER //
// E:/Angular/website-angular/src/app/components/stickynav/stickynav.component.ts